import moment from 'moment'
import Vue from 'vue'
import get from 'lodash-es/get'
export const vueFilterRegister = () => {
  Vue.filter('isConnect', (err, string) => {
    if (err === 'Connection fail') return 'Lỗi kết nối'
    else return string
  })
  Vue.filter('price', (priceNumber) => priceNumber.toLocaleString('en-US'))
  Vue.filter('ordinalNumber', (item, list) => list.indexOf(item) + 1)
  Vue.filter('ddmmyyyy', (isoStr) => (isoStr ? moment(isoStr).format('DD/MM/YYYY') : ''))
  Vue.filter('ddmm', (isoStr) => (isoStr ? moment(isoStr).format('DD/MM') : ''))
  Vue.filter('ddmmyyyyhhmm', (isoStr) => (isoStr ? moment(isoStr).format('DD/MM/YYYY HH:mm') : ''))
  Vue.filter('hhmm', (isoStr) => (isoStr ? moment(isoStr).format('HH:mm') : '--:--'))
  Vue.filter('ddmmhhmm', (isoStr) => (isoStr ? moment(isoStr).format('DD/MM HH:mm') : '--:--'))
  Vue.filter('gender', (gender) => {
    if (gender === 'male') return 'Nam'
    else if (gender === 'female') return 'Nữ'
    return 'Khác'
  })
  Vue.filter('convertFullDate', (date) => {
    if (date) {
      const currentYear = Number(localStorage.getItem('currentYear'))
      // const nextYear = currentYear + 1
      // let dateSlide = date.slice(5)
      return `${date}/${currentYear}`
      // if (+dateSlide <= 12 && +dateSlide > 6) return `${date}/${currentYear}`
      // return `${date}/${nextYear}`
      
    } else return ''
  })
  Vue.filter('_get', (any, path, defaultValue = '') => {
    return get(any, path, defaultValue)
  })
  Vue.filter('status', (status) => {
    switch (status) {
      case 'active':
        return 'Đang học'
      case 'unassignedClass':
        return 'Chưa xếp lớp'
      case 'reserved':
        return 'Bảo lưu'
      // case 'graduated':
      //   return 'Đã tốt nghiệp'
      case 'left':
        return 'Đã nghỉ'
    }
  })
  Vue.filter('statusColor', (status) => {
    switch (status) {
      case 'active':
        return '#46BE8A'
      case 'unassignedClass':
        return 'blue-grey'
      case 'reserved':
        return 'orange'
      case 'graduated':
        return 'primary'
      case 'left':
        return 'red'
      default:
        return 'grey'
    }
  })
  Vue.filter('getStudentCode', (code) => {
    return code.substr(0, 5)
  })
  Vue.filter('getTeacherCode', (code) => {
    return code.substr(0, 5)
  })
  Vue.filter('classStatusColor', (status) => {
    switch (status) {
      case 'running':
        return '#46BE8A'
      default:
        return 'primary'
    }
  })
  Vue.filter('busStatus', (status) => {
    switch (status) {
      case 'inactive':
        return 'Đã ngưng'
      default:
        return 'Đang hoạt động'
    }
  })
  Vue.filter('busStatusColor', (status) => {
    switch (status) {
      case 'inactive':
        return 'red'
      default:
        return 'green'
    }
  })
  Vue.filter('busCheckinStatus', (status) => {
    switch (status) {
      case 'running':
        return 'Đang di chuyển'
      case 'pickedup':
        return 'Đã đón Học viên'
      case 'finished':
        return 'Đã hoàn thành'
      default:
        return '---'
    }
  })
  Vue.filter('busCheckinColor', (status) => {
    switch (status) {
      case 'running':
        return 'orange'
      case 'pickedup':
        return 'primary'
      case 'finished':
        return 'green'
      default:
        return '---'
    }
  })
  Vue.filter('classStatus', (status) => {
    switch (status) {
      case 'running':
        return 'Đang học'
      case 'opened':
        return 'Đang chờ'
      case 'done':
        return 'Kết thúc'
      default:
        return ''
    }
  })
  Vue.filter('getAcademicLevel', (level) => {
    switch (level) {
      case 'primary':
        return '1'
      case 'secondary':
        return '2'
      case 'high':
        return '3'
      default:
        return ''
    }
  })
  Vue.filter('getContactBookPhones', (item) => {
    if (!item.contactBook || !item.contactBook.phones) return ''
    if (typeof item.contactBook.phones === 'string') return item.contactBook.phones
    return item.contactBook.phones.join(', ')
  })
  Vue.filter('getNotificationMethod', (item) => {
    if (!item.contactBook) return ''
    if (item.contactBook.isSms && item.contactBook.isApp) return 'SMS | APP'
    if (item.contactBook.isSms) return 'SMS'
    if (item.contactBook.isApp) return 'APP'
  })
  Vue.filter('getSenderMethod', (senderMethod) => {
    if (!senderMethod) return ''
    if (senderMethod === 'auto') return 'Tự động'
    if (senderMethod === 'sms') return 'SMS'
    if (senderMethod === 'app') return 'APP'
  })
  Vue.filter('getPostType', (type) => {
    switch (type) {
      case 'mark':
        return 'Sổ điểm'
      case 'violation':
        return 'Ghi chú cần theo dõi'
      case 'notification':
        return 'Thông báo'
      case 'tuitionFee':
        return 'Học phí'
      case 'diligence':
        return 'Chuyên cần'
      case 'schedule':
        return 'Thời khóa biểu'
      case 'onlineStudy':
        return 'Học tập online'
      case 'other':
        return 'Khác'
      default:
        return ''
    }
  })
  Vue.filter('getConfig', (config) => {
    if (config === 'immediately') return 'Soạn riêng'
    return 'Tự động'
  })
  Vue.filter('getSendNotiStatus', (status) => {
    switch (status) {
      case 'success':
        return 'Thành công'
      case 'error':
        return 'Gửi lỗi'
      default:
        return ''
    }
  })
  Vue.filter('getSendNotiStatusColor', (status) => {
    switch (status) {
      case 'success':
        return '#46BE8A'
      case 'error':
        return 'red'
      default:
        return 'grey'
    }
  })
  Vue.filter('violation', (type) => {
    switch (type) {
      case 'commendation':
        return 'Về học tập'
      case 'violation':
        return 'Về nội dung khác'
      default:
        return '---'
    }
  })
  Vue.filter('getMarkType', (type) => {
    switch (type) {
      case 'mark':
        return 'Điểm số'
      case 'evaluate':
        return 'Nhận xét'
      default:
        return '---'
    }
  })
  Vue.filter('getEvaluate', (number) => {
    switch (number) {
      case 1:
        return 'Đạt'
      case 0:
        return 'Chưa Đạt'
      default:
        return '---'
    }
  })
  Vue.filter('factorType', (type) => {
    switch (type) {
      case 'factor-1':
        return 'HS1'
      case 'factor-2':
        return 'HS2'
      case 'factor-3':
        return 'HS3'
      default:
        return '---'
    }
  })
  Vue.filter('getAttendanceStatus', (status) => {
    switch (status) {
      case 'attended':
        return 'Có mặt'
      case 'absent':
        return 'Vắng mặt'
      case 'none':
        return 'Chưa điểm danh'
      default:
        return '---'
    }
  })
  Vue.filter('getBusStudentAttendanceStatus', (status) => {
    switch (status) {
      case 'notCheckin':
        return 'Chưa lên xe'
      case 'absent':
        return 'Vắng mặt'
      case 'attendance':
        return 'Đã lên xe'
      case 'notLeft':
        return 'Chưa xuống xe'
      case 'left':
        return 'Đã xuống xe'
      default:
        return 'Khác'
    }
  })
  Vue.filter('getAttendanceStatusColor', (status) => {
    switch (status) {
      case 'attended':
        return '#46BE8A'
      case 'absent':
        return 'orange'
      case 'none':
        return '#919191'
      default:
        return '#919191'
    }
  })
  Vue.filter('teacherStatus', (status) => {
    switch (status) {
      case 'active':
        return 'Đang dạy'
      case 'pause':
        return 'Tạm nghỉ'
      case 'left':
        return 'Đã nghỉ'
      default:
        return '---'
    }
  })
  Vue.filter('teacherType', (status) => {
    switch (status) {
      case 'long-term':
        return 'Biên chế'
      case 'short-term':
        return 'Thỉnh giảng'
      case 'short-term-contract':
        return 'Hợp đồng'
      default:
        return '---'
    }
  })
  Vue.filter('teacherLevel', (level) => {
    switch (level) {
      case 'master-level':
        return 'Thạc sĩ'
      case 'university-level':
        return 'Đại học'
      case 'college-level':
        return 'Cao đẳng'
      default:
        return ''
    }
  })
  Vue.filter('classType', (type) => {
    switch (type) {
      case 'coreCurriculum':
        return 'Chính khóa'
      case 'extraCurriculum':
        return 'Ngoại khóa'
      default:
        return '---'
    }
  })
  Vue.filter('getContactBookStatus', (student) => {
    if (!student.contactBook || !student.contactBook.status) return 'Chưa cài đặt'
    if (student.contactBook.status === 'active') return 'Hoạt động'
    if (student.contactBook.status === 'locked') return 'Đã khóa'
    return 'Chưa cài đặt'
  })
  Vue.filter('getContactBookStatusColor', (student) => {
    if (!student.contactBook || !student.contactBook.status) return 'cancel'
    if (student.contactBook.status === 'active') return 'success'
    if (student.contactBook.status === 'locked') return 'error'
    return 'cancel'
  })
  Vue.filter('dayPeriod', (index) => {
    if (index > 0 && index <= 5) return 'Sáng'
    else if (index > 5 && index <= 10) return 'Chiều'
    return '---'
  })
  Vue.filter('scheduleDay', (day) => {
    switch (day) {
      case '1':
      case 1:
      case 'monday':
        return 'Thứ Hai'
      case '2':
      case 2:
      case 'tuesday':
        return 'Thứ Ba'
      case '3':
      case 3:
      case 'wednesday':
        return 'Thứ Tư'
      case '4':
      case 4:
      case 'thursday':
        return 'Thứ Năm'
      case '5':
      case 5:
      case 'friday':
        return 'Thứ Sáu'
      case '6':
      case 6:
      case 'saturday':
        return 'Thứ Bảy'
      case '0':
      case 0:
      case 'sunday':
        return 'Chủ Nhật'
      default:
        return ''
    }
  })
  Vue.filter('shortScheduleDay', (day) => {
    switch (day) {
      case '1':
      case 1:
      case 'monday':
        return 'T2'
      case '2':
      case 2:
      case 'tuesday':
        return 'T3'
      case '3':
      case 3:
      case 'wednesday':
        return 'T4'
      case '4':
      case 4:
      case 'thursday':
        return 'T5'
      case '5':
      case 5:
      case 'friday':
        return 'T6'
      case '6':
      case 6:
      case 'saturday':
        return 'T7'
      default:
        return ''
    }
  })
  Vue.filter('numberToWeekDay', (day) => {
    switch (day) {
      case '0':
      case 0:
        return 'sunday'
      case '1':
      case 1:
        return 'monday'
      case '2':
      case 2:
        return 'tuesday'
      case '3':
      case 3:
        return 'wednesday'
      case '4':
      case 4:
        return 'thursday'
      case '5':
      case 5:
        return 'friday'
      case '6':
      case 6:
        return 'saturday'
      default:
        return ''
    }
  })
  Vue.filter('getBusTimeline', (busSchedule) => {
    if (busSchedule.periodTime === 'AM') {
      return busSchedule.direction === 'in' ? 'Đón Học viên buổi sáng' : 'Trả Học viên buổi trưa'
    } else if (busSchedule.periodTime === 'PM') {
      return busSchedule.direction === 'in' ? 'Đón Học viên buổi chiều' : 'Trả Học viên buổi chiều'
    } else return ''
  })
  Vue.filter('dishType', (type) => {
    switch (type) {
      case 'main':
        return 'Món chính'
      case 'side':
        return 'Món phụ'
      default:
        return ''
    }
  })
  Vue.filter('selectedMenu', (type) => {
    switch (type) {
      case 'menu1':
        return 'Thực đơn 1'
      case 'menu2':
        return 'Thực đơn 2'
      case '0':
        return 'Không đăng ký'
      default:
        return 'Chưa đăng ký'
    }
  })
  Vue.filter('mealTransferStatus', (type) => {
    switch (type) {
      case 'ate':
        return 'Đã ăn'
      case 'not-eat':
        return 'Chưa ăn'
      case 'not-receive':
        return 'Không ăn'
      case 'validCancel':
        return 'Hủy hợp lệ'
      default:
        return '---'
    }
  })
  Vue.filter('getColor', (status) => {
    switch (status) {
      case 'active':
        return '#46BE8A'
      case 'unassignedClass':
        return 'blue-grey'
      case 'reserved':
        return 'orange'
      case 'graduated':
        return 'primary'
      case 'left':
        return 'red'
      default:
        return 'grey'
    }
  })
  Vue.filter('getSystemAttendanceStatus', (status) => {
    return status === 'disable' ? 'Tắt' : 'Bật'
  })
  Vue.filter('getTimeFromTimestampt', (timestampt) => {
    if (timestampt) {
      return moment(Number.parseInt(timestampt)).format('HH:mm')
    }
    return '--:--'
  })
  Vue.filter('gradePerLevel', (type) => {
    switch (type) {
      case 'primary':
        return 'Học phần 1 * Học phần 2 * Học phần 3 * Học phần 4 * Học phần 5'
      case 'secondary':
        return 'Học phần 6 * Học phần 7 * Học phần 8 * Học phần 9'
      case 'high':
        return 'Học phần 10 * Học phần 11 * Học phần 12'
      default:
        return ''
    }
  })
}
Vue.filter('absentRequestStatus', (status) => {
  switch (status) {
    case 'created':
      return 'Chưa chấp nhận'
    default:
      return 'Đã chấp nhận'
  }
})
Vue.filter('absentRequestStatusColor', (status) => {
  switch (status) {
    case 'created':
      return '#D3D3D3'
    default:
      return '#46BE8A'
  }
})
Vue.filter('gradeTitleAndCode', (grade) => {
  if (!grade) return '--'
  return `${grade.code} - ${grade.title}`
})
